
import React, { Suspense, lazy } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import { UserStoryState } from "src/context/UserStoryState";
import Home from "src/pages/Home";
import NotFound from "src/pages/NotFound";
import OpCodeSearch from "src/pages/OpCodeSearch";
import OpCodeCreate from "src/pages/OpCodeCreate";
import OpCodeBulkCreate from "src/pages/OpCodeBulkCreate";
import OpCodeSurvey from "src/pages/OpCodeSurvey";
import DynamicImport from "src/pages/UserStory/dynamicImport";
import { ProgressClaimForm } from "src/pages/Portal/portal";
import Cui from "src/components/Cui";
import Avatar from "./components/Avatar";
import DefaultHome from "src/pages/DefaultHome";
import "./App.css";
import ChatPage from "src/components/chat";
// Default login and signup components
import Login from "src/pages/Login/login.js";
import Signup from "src/pages/Signup/signup";
import FeedbackForm from "./pages/UserStory/NATC/FeedbackForm.jsx"
import TemplatePage from "src/pages/TemplatePage/TemplatePage";
import { useNavigate } from "react-router-dom";

// Convert static imports to lazy imports
const Homereg = lazy(() => import("./pages/UserStory/665467d84b7c867c744381a0/app_6o3C3auUDicGqkSNwSezBVF4/booking/app/page"));
const ThankYouPage = lazy(() => import("./pages/UserStory/665467d84b7c867c744381a0/app_6o3C3auUDicGqkSNwSezBVF4/booking/components/ThankYou"));
const CourseRunsPage = lazy(() => import("./pages/UserStory/665467d84b7c867c744381a0/app_6o3C3auUDicGqkSNwSezBVF4/booking/app/course-runs/page"));
const Checkout = lazy(() => import("./pages/UserStory/665467d84b7c867c744381a0/app_6o3C3auUDicGqkSNwSezBVF4/booking/app/checkout/page"));
const SfcPayment = lazy(() => import("./pages/UserStory/665467d84b7c867c744381a0/app_6o3C3auUDicGqkSNwSezBVF4/booking/components/SfcPayment"));
const USArchive = lazy(() => import("src/pages/UserStory/64f9f31ab8f2b3a65cbfc48d/app_FIyIhQVp3RJc3oVjWG8OEbDn/trainee/US-archive"));
const USArchiveDetail = lazy(() => import("src/pages/UserStory/64f9f31ab8f2b3a65cbfc48d/app_FIyIhQVp3RJc3oVjWG8OEbDn/trainee/US-archiveDetail"));

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

function OrgPage({ page }) {
  const { org, appid } = useParams();
  const navigate = useNavigate();

  let PageComponent = React.lazy(() =>
    import(`src/pages/UserStory/${org}/${appid}/${page.toLowerCase()}`)
      .then((module) => ({ default: module.default }))
      .catch(() => {
        // Redirect to home instead of a specific tenant
        navigate(`/`, { replace: true });
        // Return a dummy component that will be replaced by navigation
        return { default: () => null };
      })
  );

  return (
    <Suspense fallback={<PageLoader />}>
      <PageComponent />
    </Suspense>
  );
}

function App() {
  return (
    <UserStoryState>
      <Routes>
        {/* Static routes remain as they are */}
        <Route index path="/" element={<Home />} />
        <Route path="/home" element={<ProgressClaimForm />} />
        <Route path="/cui" element={<Cui />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/avatar" element={<Avatar />} />
        <Route path="/user-story/*" element={<DynamicImport />} />
        <Route path="/op-code-search" element={<OpCodeSearch />} />
        <Route path="/op-code-create" element={<OpCodeCreate />} />
        <Route path="/op-code-bulk-create" element={<OpCodeBulkCreate />} />
        <Route path="/op-code-survey" element={<OpCodeSurvey />} />
        {/* <Route path="/testPage" element={<TestPage />} /> SfcPayment*/}
        <Route path="/ascendo" element={<Homereg />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/course-runs" element={<CourseRunsPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment" element={<SfcPayment />} />
        <Route path="/pcc/:id" element={<FeedbackForm />} />
        {/* Meeting Minutes archives */}
        <Route path="/archives" element={
          <Suspense fallback={<PageLoader />}>
            <USArchive />
          </Suspense>
        } />
        <Route path="/archives/:id" element={
          <Suspense fallback={<PageLoader />}>
            <USArchiveDetail />
          </Suspense>
        } />

        <Route path="/DefaultHome" element={<DefaultHome />} />

        {/* Dynamic routes for login and signup based on organization and app ID */}
        <Route path="/:org/:appid/signup" element={<OrgPage page="signup" />} />
        <Route path="/:org/:appid/login" element={<OrgPage page="login" />} />
        <Route path="/templatePage" element={<TemplatePage />} />

        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </UserStoryState>
  );
}

export default App;